import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "@/pages/Index";
import About from "@/pages/About";
import MembershipPrograms from "@/pages/MembershipPrograms";
import WisdomBoard from "@/pages/WisdomBoard";
import Login from "@/pages/Login";
import RelationshipQuiz from "@/pages/RelationshipQuiz";
import LifeQuiz from "@/pages/LifeQuiz";
import NotFound from "@/pages/NotFound";
import ThePath from "@/pages/ThePath";
import HarmonyApp from "@/pages/HarmonyApp";
import FreeWebinar from "@/pages/FreeWebinar";
import TermsAndConditions from "@/pages/TermsAndConditions";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import RefundPolicy from "@/pages/RefundPolicy";
import ShippingPolicy from "@/pages/ShippingPolicy";
import ContactUs from "@/pages/ContactUs";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/membership-programs" element={<MembershipPrograms />} />
            <Route path="/wisdom-board" element={<WisdomBoard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/discovery/relationship-quiz" element={<RelationshipQuiz />} />
            <Route path="/discovery/life-quiz" element={<LifeQuiz />} />
            <Route path="/harmony-app" element={<HarmonyApp />} />
            <Route path="/free-webinar" element={<FreeWebinar />} />
            <Route path="/the-path" element={<ThePath />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/cancellation-and-refund-policy" element={<RefundPolicy />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
            <Route path="/delivery-policy" element={<ShippingPolicy />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
